export interface TcNumberOption {
  label: string;
  value: string;
}

export const normalizeTcSearchValue = (value: unknown): string => {
  if (typeof value === "string") {
    return value.trim();
  }

  if (value && typeof value === "object" && "value" in value) {
    const selectedValue = (value as { value?: unknown }).value;
    return typeof selectedValue === "string" ? selectedValue.trim() : "";
  }

  return "";
};

export const mapTcNumberOptions = (payload: unknown): TcNumberOption[] => {
  if (!payload || typeof payload !== "object") {
    return [];
  }

  let response = (payload as { response?: unknown }).response;
  if (typeof response === "string") {
    try {
      response = JSON.parse(response);
    } catch {
      return [];
    }
  }

  if (!Array.isArray(response)) {
    return [];
  }

  const tcNumbers = response
    .filter((item): item is string => typeof item === "string")
    .map((item) => item.trim())
    .filter(Boolean);

  return Array.from(new Set(tcNumbers)).map((tcNo) => ({
    label: tcNo,
    value: tcNo,
  }));
};
